import { InjectionToken } from '@angular/core';
import { HubConnection, HubConnectionBuilder, IHttpConnectionOptions } from '@microsoft/signalr';

export type HubConnectionFactory = (url: string, options: IHttpConnectionOptions) => HubConnection;

export const HUB_CONNECTION_FACTORY = new InjectionToken<HubConnectionFactory>('HubConnectionFactory', {
  providedIn: 'root',
  factory: () => (url: string, options: IHttpConnectionOptions) =>
    new HubConnectionBuilder()
      .withUrl(url, options)
      .withAutomaticReconnect()
      .build()
});
